import type { ErrorResponse } from "@services/sdk";
import type { IFelixClient } from "@services/sdk/interfaces";
import { useCallback } from "react";

export abstract class PaymentDataProvider {
	getPaymentToken!: () => Promise<string | ErrorResponse>;
}

const usePaymentDataProvider = (
	clientRef: IFelixClient,
): PaymentDataProvider => {
	const getPaymentToken = useCallback(async (): Promise<
		string | ErrorResponse
	> => {
		if (!clientRef) {
			throw new Error("clientRef is null");
		}

		const result = await clientRef.getPaymentToken();
		if (result.isOk()) {
			return result.getSuccess();
		}

		return result.getFailure();
	}, [clientRef]);

	return {
		getPaymentToken,
	};
};

export default usePaymentDataProvider;
